export const PHONE_COUNTRY = 'phone_country';
export const PHONE = 'phone';
export const PHONE_STRICT = 'phone_strict';
export const TEL = 'tel';
export const EMAIL = 'email';
export const TEXT = 'text';
export const TEXTAREA = 'textarea';
export const PAN = 'pan';
export const CVV = 'cvv';
export const EXP_DATE = 'exp_date';
export const CHECK_BOX = 'check_box';
export const COUNTRY = 'country';
export const DATE = 'date';
export const BANK_ACCOUNT = 'bank_account';
export const DROP_BOX = 'drop_box';
export const DROP_BOX_MODAL = 'drop_box_modal';
export const SBP_DROP_BOX = 'sbp_drop_box';
export const ZIP = 'zip';
export const BIK = 'bik';
export const AUTOCOMPLETE_ADDRESS = 'autocomplete_address';
export const AUTOCOMPLETE_POST_CODE = 'autocomplete_post_code';
export const ALIPAY_FREE = 'alipay_free';
export const UPLOAD_DOC = 'upload_doc';
export const ATTACHMENT = 'attachment';
export const MASTERCARD_FREE = 'mastercard_free';
export const FILE = 'file';
export const SEPA_FREE = 'sepa_free';
export const HIDDEN = 'hidden';
export const DEVICE_SCREEN_HEIGHT = 'device_screen_height';
export const DEVICE_SCREEN_WIDTH = 'device_screen_width';
export const SCREEN_HEIGHT = 'screen_height';
export const SCREEN_WIDTH = 'screen_width';
